import type { CandidateStatusId } from '@/types/candidate';

export type StageTransitionWarningRule = {
  id: string;
  toStage: CandidateStatusId;
  fromStages?: CandidateStatusId[];
  description: string;
};

const stageTransitionWarningRules: StageTransitionWarningRule[] = [
  {
    id: 'require-warning-on-aangenomen',
    toStage: 'aangenomen',
    description:
      'Let op: bij het verplaatsen naar "Aangenomen" willen we eerst aanvullende gegevens vastleggen.',
  },
];

export const findStageTransitionWarningRule = (
  fromStage: CandidateStatusId | null | undefined,
  toStage: CandidateStatusId | null | undefined,
): StageTransitionWarningRule | null => {
  if (!toStage) {
    return null;
  }

  const match = stageTransitionWarningRules.find((rule) => {
    if (rule.toStage !== toStage) {
      return false;
    }

    if (!rule.fromStages || rule.fromStages.length === 0) {
      return true;
    }

    return Boolean(fromStage && rule.fromStages.includes(fromStage));
  });

  return match ?? null;
};

export const getStageTransitionWarningRules = (): StageTransitionWarningRule[] =>
  stageTransitionWarningRules.slice();
